import React, { useEffect, useState } from 'react';
import './styles';
import UIMultiImageSelect from '../../../../../components/UI/UIMultiImageSelect';
import { TYPES } from '../../../../../components/UI/UIMultiImageSelect/config';
import { useLazyQuery } from '@apollo/react-hooks';
import Queries from '../../../../../utils/API/Queries';
import * as strings from './strings';
import { FILE_STATUS_LIVE, FILE_TYPE_VIDEO } from '../../../../../utils/Config/Constants';
import { GET_LISTING_AGGREGATED_VIDEOS } from './queries';
import PLUpload from '../../../../../components/PL/PLUpload';

export default function ListingVideos({ listingId }: ListingVideosProps) {
	const [aggregatedVideos, setAggregatedVideos] = useState<FileType[]>();
	const [listing, setListing] = useState<ListingType>();

	const [getListing, { data: listingData }] = useLazyQuery(GET_LISTING_AGGREGATED_VIDEOS, { variables: { id: listingId } });
	const [getAggregatedVideos, { data: aggregatedVideosData }] = useLazyQuery(Queries.GET_FILES_WITH_QUERY);

	useEffect(() => {
		(async () => {
			await getListing();
		})();
	}, []);

	useEffect(() => {
		if (listingData) {
			const fetchedListing: ListingType = listingData['listing'];
			setListing(fetchedListing);
			getAggregatedVideos({
				variables: { order: [['index']], limit: 1000, query: { listingId: fetchedListing.id, status: FILE_STATUS_LIVE, type: FILE_TYPE_VIDEO, isActive: true } }
			});
		}
	}, [listingData]);

	useEffect(() => {
		if (aggregatedVideosData) {
			setAggregatedVideos(aggregatedVideosData['files']);
		}
	}, [aggregatedVideosData]);

	if (!listing || !aggregatedVideos) return null;

	const renderContent = () => {
		return (
			<UIMultiImageSelect
				emptySetTitle={strings.emptySetTitle}
				emptySetDescription={strings.emptySetDescription}
				type={TYPES.video}
				updateData={getListing}
				files={aggregatedVideos}
				listing={listing}
				disableSort={false}
				rightItem={renderUpload()}
			/>
		);
	};

	const renderUpload = () => {
		return (
			<PLUpload
				multiple={true}
				localeTranslations={strings.videosLocaleTranslations}
				fileType={FILE_TYPE_VIDEO}
				onFileUploadComplete={getListing}
				postData={{ listingId: listing.id }}
				uploadStatus={FILE_STATUS_LIVE}
			/>
		);
	};
	return <div className='listingVideos'>{renderContent()}</div>;
}
